import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import {
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Nullable } from "@playcharge/common/models/backend/nullable";

@Component({
    selector: "app-confirm-dialog",
    standalone: true,
    imports: [CommonModule, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
    templateUrl: "./confirm-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
    public data: { message: Nullable<string> } = inject(MAT_DIALOG_DATA);
}
